import React, { useMemo, useCallback } from 'react';
import shortid from 'shortid';
import styled, { css } from '../../styled';
const StyledTd = styled.td `
  ${({ minWidth, textAlign, rowVerticalAlign, offsetLeft, offsetRight }) => css `
    box-sizing: border-box;
    min-width: ${`${minWidth}rem`};
    width: ${`${minWidth}rem`};
    font-size: 0.875rem;
    padding: 0.75rem 0.5rem;
    text-align: ${textAlign || 'left'};
    vertical-align: ${rowVerticalAlign};
    left: ${offsetLeft ? `${offsetLeft}rem` : 0};
    right: ${`${offsetRight}rem`};
  `}
`;
const StyledTbody = styled.tbody `
  ${({ theme, hoverable, rowHeight }) => css `
    tr {
      min-height: ${`${rowHeight}rem`};
      transition: 0.2s;
      &:not(:last-child) {
        border-bottom: solid 0.0625rem ${theme.colors.INK_200};
      }
      ${hoverable &&
    `
        &:hover {
          ${StyledTd} {
            background-color: ${theme.colors.PRIMARY_100};
          }
        }
        &:active {
          ${StyledTd} {
            background-color: ${theme.colors.PRIMARY_200};
          }
        }
      `}
    }
  `}
`;
const StyledTr = styled.tr `
  ${({ theme, checked }) => css `
    & > td {
      ${checked && `background-color:${theme.colors.PRIMARY_200} !important`}
    }
  `}
`;
const TableBody = ({ columns, dataSource, columnConfig, hoverable, renderIndex, fixedClasses, rowVerticalAlign, onTableRowClick, rowHeight, e2eId, }) => {
    const indexClasses = useMemo(() => Object.keys(columnConfig.fixedColumns).length ? fixedClasses.column : '', [columnConfig.fixedColumns, fixedClasses.column]);
    const getFixedClasses = useCallback((key) => {
        const classes = [];
        if (columnConfig.fixedColumns[key]) {
            classes.push(fixedClasses.column);
        }
        if (columnConfig.fixedLeftShadowColumnKey.includes(key)) {
            classes.push(fixedClasses.columnLeft);
        }
        if (columnConfig.fixedRightShadowColumnKey.includes(key)) {
            classes.push(fixedClasses.columnRight);
        }
        return classes.join(' ');
    }, [columnConfig, fixedClasses]);
    const getColumnsKeyAndWidth = (columnsAry) => {
        return columnsAry.map(item => ({ key: item.key, width: item.width }));
    };
    return (React.createElement(StyledTbody, { hoverable: hoverable, rowHeight: rowHeight }, dataSource.map((source, index) => (React.createElement(StyledTr, { key: source.id || shortid.generate(), onClick: event => onTableRowClick ? onTableRowClick(event, source, index) : null, checked: source.checked, "data-e2e-id": e2eId },
        renderIndex && (React.createElement(StyledTd, { rowVerticalAlign: rowVerticalAlign, className: indexClasses }, renderIndex(index + 1))),
        getColumnsKeyAndWidth(columns).map(({ key, width }) => (React.createElement(StyledTd, { key: key, className: getFixedClasses(key), textAlign: columnConfig.fixedColumnAlign[key], rowVerticalAlign: rowVerticalAlign, offsetLeft: columnConfig.fixedOffsetLeft[key], offsetRight: columnConfig.fixedOffsetRight[key], minWidth: width }, typeof source[key] === 'function' ? source[key]() : source[key]))))))));
};
export default React.memo(TableBody);
//# sourceMappingURL=TableBody.js.map